module.exports = __webpack_public_path__ + "images/help/icn-faq-payment-7e3acb5d4d99d699772ac42236723e87.png";